module.exports = __webpack_public_path__ + "static/media/swimming_icon.93c96a9e.svg";